<template>
  <v-toolbar flat tile dense color="Neutral">
    <v-tooltip :disabled="prevTooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          class="arrow-left-thick"
          color="primaryDark"
          v-bind="attrs"
          v-on="on"
          width="40"
          min-width="40"
          :disabled="!previousMeetingId"
          :to="getMeetingURL(previousMeetingId)"
        >
          <v-icon size="16" color="#fff"> mdi-arrow-left-thick</v-icon>
        </a-btn>
      </template>
      <span> {{ $t("Prev") }}</span>
    </v-tooltip>
    <v-tooltip :disabled="nextTooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          class="ml-1 arrow-right-thick"
          v-bind="attrs"
          v-on="on"
          color="primaryDark"
          :disabled="!nextMeetingId"
          :to="getMeetingURL(nextMeetingId)"
          width="40"
          min-width="40"
        >
          <v-icon size="16" color="#fff"> mdi-arrow-right-thick</v-icon>
        </a-btn>
      </template>
      <span> {{ $t("Next") }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  name: "MeetingNavigation",
  props: {
    previousMeetingId: String,
    nextMeetingId: String,
    prevTooltip: Boolean,
    nextTooltip: Boolean,
  },
  computed: {
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    getMeetingURL(meetingId) {
      return `/meeting/${meetingId}/${this.$route.params.origin}/tenant/${this.tenantId}`;
    },
  },
};
</script>
